export default __webpack_public_path__ + "static/media/pcrwr-logo-white.86914dd9.png";